module.exports = __webpack_public_path__ + "img/157.75ebc9e7.gif";